export default __webpack_public_path__ + "static/media/syusuf_CV.492e07a8.pdf";